export default __webpack_public_path__ + "static/media/scan2pay_banner.d67976ac.png";